(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateVideoButton = (video, playing) => {
    const button = video.parentElement?.querySelector('[data-sr-video-toggle]');
    if (!button) return;
    const label = video.getAttribute('aria-label') || 'video';
    button.dataset.playing = playing ? 'true' : 'false';
    button.textContent = playing ? 'Ⅱ' : '▶';
    button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${label}`);
  };

  const loadVideo = (video, shouldPlay = false) => {
    if (!video.src && video.dataset.srVideoSrc) {
      video.src = video.dataset.srVideoSrc;
      video.load();
    }
    if (!shouldPlay) return;
    video.play().catch(() => updateVideoButton(video, false));
  };

  const setupVideos = (root) => {
    const videos = [...root.querySelectorAll('video[data-sr-video-src]')];
    videos.forEach((video) => {
      video.addEventListener('play', () => updateVideoButton(video, true));
      video.addEventListener('pause', () => updateVideoButton(video, false));
      updateVideoButton(video, false);
    });

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sr-video-toggle]');
      if (!button) return;
      const video = button.parentElement?.querySelector('video');
      if (!video) return;
      loadVideo(video);
      if (video.paused) {
        video.play().catch(() => updateVideoButton(video, false));
      } else {
        video.pause();
      }
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const shouldAutoplay = video.dataset.srAutoplay !== 'false' && !reducedMotion.matches;
        if (entry.isIntersecting) {
          loadVideo(video, shouldAutoplay);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '260px 0px', threshold: 0.12 });

    videos.forEach((video) => observer.observe(video));
  };

  const setupCarousels = (root) => {
    root.querySelectorAll('[data-sr-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-sr-track]');
      if (!track) return;
      const move = (direction) => {
        const item = track.firstElementChild;
        const gap = carousel.classList.contains('sbf-slideshow') ? 0 : 22;
        const amount = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.82;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        let left = track.scrollLeft + (direction * amount);
        if (left > max - 2) left = 0;
        if (left < 0) left = max;
        track.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      carousel.querySelector('[data-sr-previous]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-sr-next]')?.addEventListener('click', () => move(1));
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-sr-landing]:not([data-sr-ready])').forEach((root) => {
      root.dataset.srReady = 'true';
      setupVideos(root);
      setupCarousels(root);
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
